import React from 'react';
import buildRoute from 'components/buildRoute';

export const CrosstabsDetailsPage = () => {
    // ...component code...
}

const routeArgs = {
element: <CrosstabsDetailsPage />,
loader: async ({ params }) => {
        return null;
    },
};

export default buildRoute(routeArgs);